// @todo TypeScript does not include type definitions for the Reporting API yet.
export var createWindow = function createWindow() {
  return typeof window === 'undefined' ? null : window;
};